﻿import BaseDatalayerEvent from './base-datalayer-event.js';

export default class ClickNavigationEvent extends BaseDatalayerEvent {
    constructor(navigation) {
        super('click_navigation');
        this.navigation = navigation;
    }
}